<script>
  import Link from "$lib/components/Link.svelte";

  export let data;
  let clazz = "";
  export { clazz as class };

  const url = data.url || data.destination?.url;
  const text = data.text || data.trigger?.text;
</script>

<Link {url} class="!no-underline !font-normal {clazz}">
  {#if text}
    {text}
  {:else}
    <slot />
  {/if}
</Link>
